/** OpenPose COCO 스켈레톤 연결 — backend OpenPoseService.POSE_PAIRS 와 동일 */

export const OPENPOSE_POSE_PAIRS: ReadonlyArray<readonly [string, string]> = [
  ['Neck', 'RShoulder'],
  ['Neck', 'LShoulder'],
  ['RShoulder', 'RElbow'],
  ['RElbow', 'RWrist'],
  ['LShoulder', 'LElbow'],
  ['LElbow', 'LWrist'],
  ['Neck', 'RHip'],
  ['RHip', 'RKnee'],
  ['RKnee', 'RAnkle'],
  ['Neck', 'LHip'],
  ['LHip', 'LKnee'],
  ['LKnee', 'LAnkle'],
  ['Neck', 'Nose'],
  ['Nose', 'REye'],
  ['REye', 'REar'],
  ['Nose', 'LEye'],
  ['LEye', 'LEar'],
];

export type OpenPoseKeypoint = {
  p: string;
  x: number;
  y: number;
  c?: number;
};

export type OpenPoseOverlayPerson = {
  id?: number;
  unusual?: boolean;
  reason?: string | null;
  kps: OpenPoseKeypoint[];
};

export type OpenPoseOverlayPayload = {
  persons: OpenPoseOverlayPerson[];
};

export function parseOpenPoseOverlay(raw: unknown): OpenPoseOverlayPayload | null {
  if (!raw || typeof raw !== 'object') return null;
  const persons = (raw as { persons?: unknown }).persons;
  if (!Array.isArray(persons) || persons.length === 0) return null;
  const out: OpenPoseOverlayPerson[] = [];
  for (const row of persons) {
    if (!row || typeof row !== 'object') continue;
    const kpsRaw = (row as { kps?: unknown }).kps;
    if (!Array.isArray(kpsRaw) || kpsRaw.length === 0) continue;
    const kps: OpenPoseKeypoint[] = [];
    for (const kp of kpsRaw) {
      if (!kp || typeof kp !== 'object') continue;
      const p = String((kp as { p?: string }).p || '').trim();
      const x = Number((kp as { x?: number }).x);
      const y = Number((kp as { y?: number }).y);
      if (!p || !Number.isFinite(x) || !Number.isFinite(y)) continue;
      kps.push({
        p,
        x,
        y,
        c: Number((kp as { c?: number }).c),
      });
    }
    if (kps.length === 0) continue;
    out.push({
      id: Number((row as { id?: number }).id),
      unusual: Boolean((row as { unusual?: boolean }).unusual),
      reason: String((row as { reason?: string }).reason || '').trim() || undefined,
      kps,
    });
  }
  return out.length > 0 ? { persons: out } : null;
}
